import browser from "webextension-polyfill";
import { youTubeWallDetected, youTubeNavigation } from "../shared/index.js";
const adWallSelector = "ytd-enforcement-message-view-model";
const userAvatarSelector = "button#avatar-btn";
let adWallObserver;
function isElement(candidate) {
    return candidate instanceof Element;
}
async function adWallSelectorFound(hasDismiss) {
    var _a;
    adWallObserver.disconnect();
    const videoPlayer = document.querySelector("video");
    const currentPlaybackTime = (_a = videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.currentTime) !== null && _a !== void 0 ? _a : 0;
    const userLoggedIn = document.querySelectorAll(userAvatarSelector).length > 0;
    void browser.runtime.sendMessage({
        type: youTubeWallDetected,
        userLoggedIn,
        currentPlaybackTime,
        hasDismiss,
    });
}
function handleMutations(mutations) {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (!isElement(node)) {
                continue;
            }
            const matchNode = node.matches(adWallSelector)
                ? node
                : node.querySelector(adWallSelector);
            if (matchNode) {
                const hasDismiss = !!matchNode.querySelector("#dismiss-button");
                void adWallSelectorFound(hasDismiss);
                return;
            }
        }
    }
}
function initializeObserver() {
    const observer = new MutationObserver(handleMutations);
    observer.observe(document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
    });
    return observer;
}
function logInitialEvent() {
    const userLoggedIn = document.querySelectorAll(userAvatarSelector).length > 0;
    void browser.runtime.sendMessage({ type: youTubeNavigation, userLoggedIn });
}
function handleLoadEvent() {
    window.onload = null;
    setTimeout(() => {
        logInitialEvent();
    }, 5000);
}
function checkWindow() {
    if (window.parent !== window) {
        return;
    }
    window.onload = handleLoadEvent;
}
export function start() {
    adWallObserver = initializeObserver();
    checkWindow();
}
